<template>
  <div class="btn ml-0 p-0">
    <div v-on:click="goBack()" class="back-btn">
      <img
        src="@/assets/img/icons/arrow-circle-right.svg"
        class="img-fluid back-img"
        :width="`${width}`"
      />
      <a class="font-weight-bold mt-n1"></a><!----- {{text}}-->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: "40",
    },
    text: {
      type: String,
      default: "Back",
    }
  },
};
</script>

<style>
.tooltip-element {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/UIElements/BackButton.vue